import { GiroWebappError } from 'model/error';
import { PersonToProfile } from 'model/personAccount';
import { action } from 'typesafe-actions';
import { PersonProfileActionTypes } from './types';

export const personProfileRequest = () => action(PersonProfileActionTypes.PERSON_PROFILE_REQUEST);
export const personProfileSuccess = (profile: PersonToProfile) => action(PersonProfileActionTypes.PERSON_PROFILE_SUCCESS, profile);
export const personProfileError = (error: GiroWebappError) => action(PersonProfileActionTypes.PERSON_PROFILE_ERROR, error);
export const personProfileResetState = () => action(PersonProfileActionTypes.PERSON_PROFILE_RESET_STATE);
